__turbopack_context__.v({
  "container": "preload-component-module-sass-module__axQE4a__container",
  "loader": "preload-component-module-sass-module__axQE4a__loader",
  "one": "preload-component-module-sass-module__axQE4a__one",
  "rotate-one": "preload-component-module-sass-module__axQE4a__rotate-one",
  "rotate-three": "preload-component-module-sass-module__axQE4a__rotate-three",
  "rotate-two": "preload-component-module-sass-module__axQE4a__rotate-two",
  "three": "preload-component-module-sass-module__axQE4a__three",
  "two": "preload-component-module-sass-module__axQE4a__two",
});
